export default "__VITE_ASSET__DTDimqrz__"